import { getDocument, getCollectionWithQuery } from 'db/queries';
import { updateDocument } from 'db/mutations';
import { deleteField, where } from 'firebase/firestore';
import { COLLECTION_NAME } from '.';

export const updateReferrals = async (userId) => {
  const user = await getDocument(COLLECTION_NAME, userId);

  if (user?.referredBy) {
    const referral = await getCollectionWithQuery('referrals', [
      where('referrerId', '==', user.referredBy),
      where('invitedId', '==', userId),
    ]);

    const referralId = referral?.[0]?.id;

    await updateDocument('referrals', referralId, { status: 'subscribed' });
    await updateDocument(COLLECTION_NAME, userId, {
      referredBy: deleteField(),
    });
  }
};
